// extracted by mini-css-extract-plugin
export var chevron = "_kx-4";
export var chevronExpanded = "_kx-5";
export var row = "_kx-0";
export var rowBody = "_kx-6";
export var rowDescription = "_kx-7";
export var rowHeader = "_kx-1";
export var rowTitle = "_kx-2";
export var rowTitleComplete = "_kx-3";